// The shell page scrolls by default ('page'). A few surfaces own their whole
// viewport (a map filling the page, its controls in their own panes) and must
// not sit inside an outer scroll container, or they double-scroll. Those render
// with scroll disabled ('none').
//
// Kept deliberately small: a route earns 'none' only when it is genuinely
// full-bleed (a map/ops surface managing its own layout), never merely because
// it is tall. The current set is the map surfaces; extend it as QA confirms any
// other page double-scrolls under 'page'.

import { pathIsUnder } from '@features/products/shell/tabRoutes';
import { movesTabPath } from '@features/products/productRoutes';

/** The full-bleed surfaces. One list: the app shell's scroll mode and the product shell's
 *  fill mode both read it, so a route is full-bleed in both frames or neither. The Moves Team map
 *  reads its path from the builder, so the URL shape stays in one file. */
export const FULL_BLEED_ROUTES: readonly string[] = ['/mobile-service/map', '/parts-delivery/live', movesTabPath('team')];

/** Whether a path is one of the full-bleed surfaces or a subpath of one (segment-boundary match,
 *  so '/parts-delivery/live' never matches a sibling like '/parts-delivery/livewire'). */
export function isFullBleedPath(pathname: string): boolean {
  return FULL_BLEED_ROUTES.some(route => pathIsUnder(route, pathname));
}

/** Resolve the shell page scroll mode for a path: 'none' for full-bleed route
 *  surfaces (and their subpaths), 'page' for everything else. */
export function resolveScrollMode(pathname: string): 'page' | 'none' {
  return isFullBleedPath(pathname) ? 'none' : 'page';
}
